/**
 * The single `X-Bero-Society` coordinator. There is exactly one header slot in
 * the api-client (setHeaderProvider), and two things want to set it:
 *   1. the platform console — a staffer who has "entered" a society (acting), and
 *   2. a resident who has picked an active society from the switcher.
 * A given signed-in user is only ever one of these, but the single slot means
 * whoever registers last wins — so instead each store just holds state, and THIS
 * module owns the slot and decides: acting always wins (a platform staffer's
 * impersonation must not be silently overridden), else the resident's choice.
 *
 * Import this once at app root (it self-registers on load). acting-society.ts and
 * active-society.ts no longer touch setHeaderProvider themselves.
 */
import { setHeaderProvider } from '@bero/api-client';

import { getActingSociety } from './acting-society';
import { getActiveSociety } from './active-society';

setHeaderProvider(() => {
  const acting = getActingSociety();
  if (acting) return { 'X-Bero-Society': String(acting.id) };
  const active = getActiveSociety();
  return active != null ? { 'X-Bero-Society': String(active) } : null;
});
